import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=33eed95e&scoped=true&"
import script from "./ChatWindow.vue?vue&type=script&lang=js&"
export * from "./ChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=33eed95e&scoped=true&lang=css&"
import style1 from "./ChatWindow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eed95e",
  null
  
)

export default component.exports